import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=829650d2&scoped=true"
import script from "./MyAttention.vue?vue&type=script&lang=js"
export * from "./MyAttention.vue?vue&type=script&lang=js"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=829650d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829650d2",
  null
  
)

export default component.exports